<template>
  <div class="menu-editor" :class="{ 'full-width': showWide }">
    <fade-transition>
      <OptionsMenuEditor v-if="showOptionsMenuEditor" ref="options-menu-editor" :m="editingOptionsMenu"
        :business="business" :workflow="workflow" :opts="optionsOpts" @close="closeOptionsMenu"
        @update="updateOptionsMenu" />
    </fade-transition>

    <fade-transition>
      <MenuCategoriesEditor v-if="showMenuCategoriesEditor" :categories="categories" @close="closeCategoriesEditor"
        @reorder="reorderCategories" @sort="sortMenuItemsByCategory" />
    </fade-transition>

    <div v-if="edited" class="edit-shield" @click="saveEditsReminder"></div>
    <MainBackButton />
    <!-- :forceHome="true" -->

    <!-- I think this is deprecated... -->
    <!-- <div class="header">
      <span class="is-pointer" @click="checkQuery"> Advanced Menu Editor </span>
      <i
        class="fa fa-external-link-alt is-pulled-right has-text-grey"
        style="margin-top: 2px"
        @click="viewMenu"
      />
    </div> -->

    <div class="top-bar" :style="themeBgColor">
      <p :style="themeColor">
        Advanced Menu Editor
        <i v-if="$store.state.width > 600" class="fa fa-arrows-alt-h" style="margin-left: 6px"
          @click="showWide = !showWide" />
        <i class="fa fa-external-link-alt is-pulled-right" style="margin-top: 3px" @click="viewMenu" />
      </p>
    </div>

    <!-- <section class="notification no-scrollbar" :key="z"> -->
    <section class="wrapper no-scrollbar gpu-accelerated">
      <div class="divider" />

      <div class="row-wrapper">
        <span class="row" @click="addMenuLanguage">Languages</span>
        <span class="is-pulled-right is-uppercase" style="margin-top: 0px">
          <span class="button is-small is-white has-text-grey" @click="addMenuLanguage">
            <i class="fa fa-plus fa-sm" />
          </span>
          <span v-for="l in languages" :key="l" class="button is-small has-text-weight-medium"
            :class="{ 'is-white has-text-grey': contentLang !== l }" style="padding: 7px" @click="setContentLang(l)">{{ l
            }}</span>
        </span>
      </div>

      <!-- <div v-if="!editingItem"> -->
      <div class="divider" />

      <div class="row-wrapper">
        <div v-if="editingPreface">
          <p style="margin-bottom: 4px">
            <span class="row"> Preface </span>

            <span class="is-pulled-right">
              <span class="button is-rounded is-outlined is-small" :class="{ 'is-info': isPrefaceDefault }"
                @click="isPrefaceDefault = !isPrefaceDefault">
                Set Default
              </span>
              <i style="display: inline-block; width: 12px" />
              <span class="is-primary" :class="prefaceBtn" @click="savePreface(false)">
                <i class="fa fa-save fa-lg" />
              </span>
              <i style="display: inline-block; width: 12px" />
              <span class="is-dark" :class="prefaceBtn" @click="undoPreface">
                <i class="fa fa-undo-alt fa-lg" />
              </span>
              <i style="display: inline-block; width: 12px" />
              <span class="is-danger" :class="prefaceBtn" @click="deletePreface">
                <i class="far fa-trash-alt fa-lg" />
              </span>
            </span>
          </p>
          <!-- @keydown.enter="savePreface" -->
          <textarea class="textarea" placeholder="Menu Preface" rows="3" v-model="prefaceInput"></textarea>
        </div>
        <div v-else class="is-pointer">
          <p class="row" @click="showPreface = !showPreface">
            Preface
            <i class="far fa-window-minimize is-pulled-right" />
          </p>
          <div v-if="showPreface">
            <p v-if="preface.preface" class="preface clamp" @click="editPreface">
              <!-- <i class="fa fa-pencil-alt has-text-success is-pulled-right" /> -->
              <span>{{ preface[contentLang] || preface.preface }}</span>
            </p>
            <p v-else class="button has-text-grey" @click="editPreface">
              Set Preface
            </p>
          </div>
        </div>
      </div>

      <div v-if="$store.getters.isSuperUser">
        <div class="divider" />

        <div class="row-wrapper" style="overflow: hidden">
          <p class="is-pointer" @click="showPreOrder = !showPreOrder">
            <span class="row">
              Pre-Order
              <i class="far fa-window-minimize is-pulled-right" />
            </span>
          </p>
          <div v-if="showPreOrder" class="categories buttons has-text-centered" style="width: 100%">
            <!-- Pre-order type dropdown: when closed, always, only -->
            <span class="button" :class="{ 'is-danger': !timeOption }" @click="editTimeOptionsMenu">
              Times
            </span>
            <span class="button" :class="{ 'is-danger': !dateOption }" @click="editDateOptionsMenu">
              Dates
            </span>
          </div>
        </div>
      </div>

      <div class="divider" />

      <div class="row-wrapper">
        <p class="is-pointer" @click="showCategories = !showCategories">
          <span class="row">
            <span v-if="editingCategory" @click="stopEditCategory">
              <i class="fa fa-chevron-left" />&nbsp;Editing Category</span>
            <span v-else>
              Categories
              <span v-if="showMultipleCategoryBlobsWarning" class="tag is-danger">Multiple Category Blobs</span>
              <i class="far fa-window-minimize is-pulled-right" />
            </span>
          </span>
        </p>
        <div v-if="editingCategory" class="category-edit">
          <p style="margin-bottom: 10px">
            <span class="button" @click="editCategoryName">{{
              editingCategory.name
            }}</span>
            <span class="button is-white has-text-weight-medium has-text-grey">Contains {{
              catItemCount(editingCategory.name) }} Items</span>
            <button class="delete is-large is-pulled-right" @click="stopEditCategory" />
            <!-- <span
              class="button is-danger is-outlined is-small is-pulled-right"
              @click="deleteCategory"
              ><i class="far fa-trash-alt" />&nbsp;Delete</span
            > -->
          </p>
          <div v-for="l in languages" :key="l" class="field is-grouped">
            <div style="width: 70px; padding: 5px 0">
              {{ $t(`language.${l}`) }}
            </div>
            <div class="control has-icons-right">
              <input class="input" v-model="editingCategory[l]" />
            </div>
          </div>
          <p class="has-text-right">
            <span class="button is-danger is-outlined is-small" @click="deleteCategory">
              <i class="far fa-trash-alt" />&nbsp;Delete</span>
          </p>
          <!-- add category photo -->
        </div>
        <div v-else-if="!addingNewCategory && showCategories" ref="scrollable"
          class="categories buttons has-text-centered" style="width: 100%">
          <span class="button is-rounded has-text-grey" style="padding: 11px" @click="addCustomCategory">
            <!-- @click="addNewCategory" -->
            <i class="fa fa-plus" />
          </span>
          <!-- <span v-if="categories.length"> -->
          <!-- <draggable
            v-model="categories"
            handle=".cat-handle"
            @start="drag = true"
            @end="drag = false"
            @change="draggedCategory"
            :key="z"
            style="text-align: left"
          > -->
          <span v-for="c in categories" :key="c.name" class="button is-rounded counter-btn cat-handle"
            @click="editCategories(c)">
            {{ c.name }}&nbsp;
            <span class="has-text-link counter">{{
              catItemCount(c.name)
            }}</span>
          </span>
          <!-- </draggable> -->
          <span v-if="categories.length">
            <span class="button is-white counter-btn" @click="noCategoryInfo">
              No Category&nbsp;
              <span class="counter has-text-success" :class="{ 'has-text-danger': noCategoryCount }">{{ noCategoryCount
              }}</span>
            </span>
            <span class="button is-rounded" style="padding: 9px" @click="advancedCategories">
              <i class="fa fa-cog fa-lg" />
            </span>
          </span>
          <span v-else class="button has-text-grey" @click="addNewCategory">No Categories Set Up</span>
        </div>
        <div v-if="addingNewCategory" class="buttons new-category" style="width: 100%">
          <span class="button is-white" @click="addingNewCategory = false"><i class="fa fa-chevron-left" />&nbsp;Add
            Category</span>
          <span class="button" @click="addCustomCategory">Custom Category</span>
          <!-- <button
            class="delete is-medium"
            style="margin-left: 10%; margin-top: -9px"
            @click="addingNewCategory = false"
          /> -->
          <span v-for="n in commonCategories" :key="n" class="button" @click="addDefaultCategory(n)">{{ n }}</span>
        </div>
      </div>

      <div class="divider" />

      <div class="row-wrapper" style="overflow: hidden">
        <p class="is-pointer" @click="showOptions = !showOptions">
          <span class="row">
            Options
            <span v-if="showSyncOptions" class="tag is-danger" @click="syncOptions">Sync Options</span>
            <i class="far fa-window-minimize is-pulled-right" />
          </span>
        </p>
        <div v-if="showOptions">
          <div class="categories buttons has-text-centered" style="width: 100%">
            <span class="button is-rounded has-text-grey" style="padding: 11px" @click="editOptionsMenu(null)">
              <i class="fa fa-plus" />
            </span>
            <span v-show="!optionsMenus.length" class="button has-text-grey" @click="editOptionsMenu(null)">No Options Set
              Up</span>
            <span v-for="m in filteredOptionsMenus" :key="m.data.name" class="button is-rounded counter-btn"
              :class="{ 'is-danger': !m.data.items.length }" @click="editOptionsMenu(m)">
              {{ optionsName(m.data) }}&nbsp;
              <span class="has-text-link counter">{{
                optionsItemCount(m.id)
              }}</span>
            </span>
          </div>
          <p class="row">Private Options</p>
          <div class="categories buttons has-text-centered" style="width: 100%">
            <span class="button is-rounded has-text-grey" style="padding: 11px" @click="privateOptionsInfo">
              <i class="fa fa-plus" />
            </span>
            <span v-for="m in privateOptionsMenus" :key="m.data.name" class="button is-rounded counter-btn"
              :class="{ 'is-danger': !m.data.items.length }" @click="editOptionsMenu(m)">
              {{ optionsName(m.data) }}&nbsp;
              <span class="has-text-link counter">{{
                optionsItemCount(m.id)
              }}</span>
            </span>
          </div>
        </div>
      </div>

      <div v-if="obsoleteOptionsCount" class="button is-fullwidth is-success" style="margin-top: 6px"
        @click="clearObsoleteOptions">
        Clear obsolete options from items ({{ obsoleteOptionsCount }})
      </div>
      <!-- </div> -->

      <div class="divider" />

      <!-- <div
        v-if="editingItem"
        class="row-wrapper has-text-centered"
        style="background-color: #dde"
        @click="stopEditItem"
      >
        <span class="link"> View Menu - Close Item</span>
      </div>
      <div v-else class="row-wrapper">  -->
      <div class="row-wrapper" style="position: sticky; top: 0; z-index: 2">
        <div style="margin-bottom: 6px">
          <div v-if="showApplyActions" class="apply-actions-wrapper">
            <p @click="showApplyActions = false" style="padding-bottom: 6px">
              <span class="row"><i class="fa fa-chevron-left" />Apply Actions</span>
            </p>
            <p class="buttons apply-btns">
              <span class="button" @click="applyOutOfStock(true)">Out of Stock</span>
              <span class="button" @click="applyOutOfStock(false)">Available</span>
              <span class="button" @click="applyHidden(true)">Hidden</span>
              <span class="button" @click="applyHidden(false)">Visible</span>
              <span v-if="$store.getters.isSuperUser" class="button is-danger" @click="applyDelete">Delete</span>
            </p>
          </div>
          <div v-if="showItemFilters || search" style="padding-top: 6px">
            <span class="row" @click="toggleItemFilters"><i class="fa fa-chevron-left" />Filter Menu</span>

            <span v-if="filteredItems.length" class="apply-action-btn" @click="showApplyActions = true">Apply
              Action</span>
            <span v-if="filteredItems.length" class="apply-action-btn" style="color: black; border: 1px solid black"
              @click="
                selecting = !selecting;
              selectedItems = [];
              ">
              <span v-if="selecting">
                <i class="far fa-check-square" />
                Selecting
                <span class="selected-count">{{ selectedItems.length }}</span>
              </span>
              <span v-else> <i class="far fa-square" />&nbsp;Select</span>
            </span>

            <p style="margin-top: 10px">
              <span v-if="filter" class="selected-filter" @click="toggleItemFilters">
                <button class="delete is-small" style="margin-top: 4px" />
                {{ filter }}
              </span>
            </p>
          </div>
          <div v-else>
            <span class="row" @click="toggleSecretMenu">Menu</span>
            <span class="reorder-btn is-pulled-right" @click="reordering = !reordering">
              <i v-if="reordering" class="reordering">
                <span>Drag handles
                  <i class="fa fa-grip-lines has-text-success fa-lg" /> to
                  re-order menu </span>&nbsp;
                <button class="delete is-medium" />
              </i>
              <i v-else class="link"> Re-order </i>
            </span>
            <div v-if="showSecretMenu" class="tags">
              <span class="tag is-rounded" style="margin-left: 9px; margin-right: 9px" @click="showSecretMenu = false"><i
                  class="fa fa-times" /></span>
              <span class="tag is-dark" @click="adjustPrices">Adjust Prices</span>
              <span class="tag is-dark" @click="copyMenu">Copy Menu</span>
            </div>
          </div>
        </div>

        <div v-if="showItemFilters" class="control filters">
          <span class="button" @click="toggleItemFilters"><i class="fa fa-search" /></span>
          <span v-for="f in filters" :key="f" class="button" :class="{ 'has-text-danger': f === 'Out of Stock' }"
            @click="setFilter(f)">
            {{ f }}
          </span>
        </div>
        <div v-else class="field is-grouped">
          <div class="control">
            <span class="button" @click="toggleItemFilters">
              <i class="fa fa-filter" />
            </span>
          </div>
          <div class="control has-icons-left has-icons-right is-expanded">
            <span class="icon is-small is-left">
              <i class="fas fa-search" />
            </span>
            <input class="input" placeholder="Search menu" v-model="search" />
            <span v-if="search" class="icon is-right" style="pointer-events: initial" @click="search = null">
              <i class="fas fa-times-circle fa-lg" />
            </span>
          </div>
        </div>
      </div>
      <draggable class="items-list" v-model="items" group="people" handle=".handle" @start="drag = true"
        @end="drag = false" @change="draggedMenu" :key="z">
        <div v-for="(o, i) in filteredItems" :key="i" :data-item="o.id" class="menu-item" :class="[
          {
            'editing-item':
              editingItem === o.id || selectedItems.includes(o.id),
          },
          itemBackground(o),
        ]">
          <div class="is-flex">
            <div class="menu-pic">
              <i v-if="o.special" class="fa fa-star fa-sm has-text-info special" @click="toggleSpecial(o)" />
              <i v-if="o.flash_deal" class="fa fa-bolt fa-sm has-text-warning flash" @click="toggleSpecial(o)" />
              <figure v-if="o.pic || !o.color">
                <img v-webp="o.pic || placeholderPic" @error="defaultImg" :class="{ 'contain-img': o.contain_image }" />
              </figure>
              <figure v-else class="no-img" :style="'background-color: ' + o.color" />

              <span v-if="o.hidden" class="tag is-dark out-of-stock">Hidden</span>
              <span v-else-if="o.out_of_stock" class="tag is-danger out-of-stock">Out of stock</span>
            </div>
            <div style="flex: 1; margin-right: 8px" @click="selectItem(o)">
              <!-- @click="editItem(o.id)" -->
              <div class="is-flex">
                <p class="item-name" :class="{ clamp: editingItem !== o.id }">
                  {{ o.name }}
                </p>
                <p style="flex-shrink: 1; margin-top: 4px">
                  <span class="cat-tag has-text-link">
                    <span v-if="o.category">{{
                      categoryName(o.category)
                    }}</span>
                    <span v-else class="has-text-black">Set Category</span>
                  </span>
                </p>
              </div>
              <div style="margin-top: 4px">
                <span :class="{ discount: o.discount }">
                  <span v-if="o.free_gift" class="has-text-danger has-text-weight-bold"><i class="fa fa-gift" />&nbsp;Free
                    Gift over
                    {{ currencySymbol(business.country)
                    }}{{ o.free_gift }}</span>
                  <span v-else-if="o.price > 0">{{ currencySymbol(business.country) }}{{ o.price
                  }}<span v-if="o.by_weight" class="has-text-grey has-text-weight-medium">{{
  translateByWeight(o.by_weight) }}</span><span v-if="o.by_weight" class="estimated-weight">{{
    o.estimated_weight || "???" }} grams</span></span>
                  <span v-else>From {{ currencySymbol(business.country)
                  }}{{ o.price_from || "0" }}</span>
                </span>
                <span v-if="o.discount" class="has-text-danger has-text-weight-medium" style="margin-left: 10px">{{
                  currencySymbol(business.country)
                }}{{ discountedPrice(o) }}</span>
                <span class="is-pulled-right has-text-weight-medium">
                  <span v-if="o.tags && o.tags.length" class="has-text-info" style="margin-right: 5px; font-size: 0.8em">
                    {{ o.tags.join(", ") }}
                  </span>
                  <i v-show="o.options && o.options.length" class="fa fa-ellipsis-h has-text-black"
                    style="font-size: 0.9em; margin-right: 5px" />
                  <i v-show="o.schedule && o.schedule.length" class="fa fa-calendar-alt" style="font-size: 0.8em" />
                </span>
              </div>
            </div>
            <!-- <div v-if="reordering" class="reorder">
              <span
                class="tag is-rounded is-medium handle"
                style="padding: 6px; margin: 4px"
              >
                <i class="fa fa-grip-lines has-text-success fa-lg" />
              </span>
            </div> -->
            <!-- <div v-if="reordering" class="column is-narrow has-text-left"> -->
            <div v-if="reordering" class="action-col">
              <p class="handle">
                <i class="fa fa-grip-lines has-text-success fa-lg" />
              </p>
            </div>
            <div v-if="selecting" class="action-col" @click="toggleSelect(o)">
              <i v-if="selectedItems.includes(o.id)" class="far fa-check-square has-text-black fa-lg" />
              <i v-else class="far fa-square has-text-grey fa-lg" />
            </div>
          </div>
          <!-- <collapse-transition> -->
          <!-- <div v-show="editingItem === o.id" class="advanced"> -->
          <div v-show="false" class="advanced">
            <!-- :class="itemBackground(o)" -->
            <!-- <span
              class="close-item button is-rounded is-white"
              @click="stopEditItem"
            >
              <i class="fa fa-chevron-up" />
            </span> -->
            <!-- <span
              class="delete is-pulled-right is-medium"
              @click="stopEditItem"
            /> -->
            <p style="margin-bottom: 8px">
              <span style="margin-left: 5px" @click="toggleSpecial(o)">
                <i v-if="o.special" class="fa fa-star has-text-info" />
                <i v-else class="far fa-star has-text-grey" />
                Special
              </span>
              <span class="is-pulled-right">
                <span style="font-weight: 500">
                  <span v-if="o.out_of_stock" class="has-text-danger">Out of stock</span>
                  <span v-else class="has-text-primary">Available</span> </span>&nbsp;
                <toggle-button style="top: -1px" :value="!o.out_of_stock"
                  :color="{ checked: '#00D1B2', unchecked: 'red' }" :height="22" :width="40"
                  @change="toggleOutOfStock(o)" />
              </span>
            </p>
            <div class="field has-addons">
              <div class="control wleft">
                <a class="button is-light" @click="discountInfo">
                  <i class="fa fa-percent fa-sm" />&nbsp;Discount
                </a>
              </div>
              <div class="control is-expanded has-icons-right has-icons-left">
                <input class="input" type="number" v-model="o.discount"
                  :placeholder="isPercentDiscount(o) ? 'Percent' : 'Number'" @keydown="edited = true"
                  @change="validateDiscount(o)" />
                <span class="icon is-left has-text-link" style="pointer-events: initial" @click="toggleDiscountType(o)">
                  <i v-if="isPercentDiscount(o)" class="fas fa-percentage link" />
                  <i v-else class="fa fa-money-bill-alt link" />
                </span>
                <span class="icon is-small is-right has-text-grey" style="pointer-events: initial"
                  @click="clearDiscount(o)">
                  <i class="far fa-trash-alt fa-sm" />
                </span>
              </div>
              <div class="control" @click="infoToast('Price after discount')">
                <a class="button is-disabled has-text-danger">{{ currencySymbol(business.country)
                }}{{ discountedPrice(o) }}</a>
              </div>
            </div>

            <!-- Category -->
            <div v-if="editCategory" class="choose-category">
              <a class="button is-white" style="padding: 6px" @click="editCategory = false">
                <i class="fa fa-chevron-left" />Edit Category
              </a>
              <!-- <span
                v-if="o.category"
                class="button is-light is-pulled-right"
                @click="setCategory(o, null)"
                >Remove</span
              > -->
              <span class="button has-text-success is-pulled-right" @click="addCustomCategory"><i
                  class="fa fa-plus" />&nbsp;New Category</span>
              <div class="buttons" style="margin-top: 6px">
                <!-- <a
                  class="button is-rounded"
                  style="padding: 9px"
                  @click="setCategory(o, null)"
                >
                  <i class="fa fa-times-circle" />
                </a> -->
                <a v-for="c in categories" :key="c.name" class="button is-rounded"
                  :class="{ 'is-link': o.category === c.name }" @click="setCategory(o, c.name)">{{ c[contentLang] ||
                    c.name }}</a>
                <span v-show="!categories.length" class="button has-text-grey" @click="addNewCategory">No Categories Set
                  Up</span>
              </div>
            </div>
            <div v-else class="field has-addons">
              <div class="control wleft">
                <a class="button is-light" @click="editCategory = true">
                  <i class="fa fa-list-ul fa-sm" />&nbsp;Category
                </a>
              </div>
              <div class="control is-expanded">
                <a class="button is-disabled is-fullwidth" @click="editCategory = true">
                  <span v-if="o.category" class="has-text-info">
                    {{ categoryName(o.category) }}
                  </span>
                  <span v-else class="click-set">Click to set</span>
                </a>
              </div>
            </div>

            <!-- Tags -->
            <div v-if="editTags" class="choose-category">
              <a class="button is-white" style="padding: 6px" @click="editTags = false">
                <i class="fa fa-chevron-left" />Edit Tags
              </a>
              <a class="button has-text-success is-pulled-right" @click="createTag(o)"><i class="fa fa-plus" />&nbsp;New
                Tag</a>
              <div class="buttons" style="margin-top: 6px">
                <!-- <a
                  class="button is-rounded"
                  style="padding: 10px"
                  @click="createTag(o)"
                >
                  <i class="fa fa-plus" />
                </a> -->
                <a v-for="t in allTags" :key="t" class="button is-rounded is-capitalized"
                  :class="{ 'is-link': isTag(o, t) }" @click="setTag(o, t)">{{ t }}</a>
              </div>
            </div>
            <div v-else class="field has-addons">
              <div class="control wleft">
                <a class="button is-light" @click="editTags = true">
                  <i class="fa fa-tags fa-sm" />&nbsp;Tags
                  <span style="width: 25px" />
                </a>
              </div>
              <div class="control is-expanded">
                <a class="button is-disabled is-fullwidth" @click="editTags = true">
                  <span v-if="o.tags && o.tags.length" class="has-text-info is-capitalized">
                    {{ o.tags.join(", ") }}
                  </span>
                  <span v-else class="click-set">Click to set</span>
                </a>
              </div>
            </div>

            <!-- Options -->
            <div v-if="editOptions" class="choose-category">
              <div>
                <a class="button is-white" style="padding: 6px" @click="editOptions = false">
                  <i class="fa fa-chevron-left" />Edit Options
                </a>
                <a class="button has-text-success is-pulled-right" @click="editOptionsMenu(null)">
                  <i class="fa fa-plus" />&nbsp;New Options
                </a>
              </div>
              <div class="buttons" style="margin-top: 6px">
                <a v-for="m in optionsMenus" :key="m.id" class="button is-rounded is-capitalized"
                  :class="{ 'is-link': isOptions(o, m) }" @click="setOptions(o, m)">{{ optionsName(m.data) }}</a>
              </div>
            </div>
            <div v-else class="field has-addons">
              <div class="control wleft">
                <a class="button is-light" @click="editOptions = true">
                  <i class="fa fa-ellipsis-h fa-sm" />&nbsp;Options
                </a>
              </div>
              <div class="control is-expanded">
                <a class="button is-disabled is-fullwidth" @click="editOptions = true">
                  <span v-if="o.options && o.options.length" class="has-text-info">
                    {{ optionsList(o.options) }}
                  </span>
                  <span v-else class="click-set">Click to set</span>
                </a>
              </div>
            </div>

            <!-- Schedule -->
            <div v-if="editSchedule" class="choose-category">
              <a class="button is-white" style="padding: 6px" @click="editSchedule = false">
                <i class="fa fa-chevron-left" />Edit Schedule
              </a>

              <a class="button is-pulled-right" style="padding: 12px" :class="{ 'is-success': !o.schedule }"
                @click="clearSchedule(o)">
                All Days
              </a>
              <div class="buttons" style="margin-top: 6px">
                <!-- <a
                  class="button is-rounded"
                  style="padding: 12px"
                  :class="{ 'is-success': !o.schedule }"
                  @click="clearSchedule(o)"
                >
                  All Days
                </a> -->
                <a v-for="d in days" :key="d" class="button is-rounded is-capitalized"
                  :class="{ 'is-link': isScheduleDay(o, d) }" @click="setSchedule(o, d)">{{ d }}</a>
              </div>
            </div>
            <div v-else class="field has-addons">
              <div class="control wleft">
                <a class="button is-light" @click="editSchedule = true">
                  <i class="far fa-calendar-alt fa-sm" />&nbsp;Schedule
                </a>
              </div>
              <div class="control is-expanded">
                <a class="button is-disabled is-fullwidth" @click="editSchedule = true">
                  <span v-if="o.schedule && o.schedule.length" class="has-text-info is-capitalized">
                    {{ o.schedule.join(", ") }}
                  </span>
                  <span v-else class="click-set">Click to set</span>
                </a>
              </div>
            </div>
            <div>
              <span @click="toggleFlashDeal(o)">
                <span v-if="o.flash_deal" class="tag is-warning">
                  <i class="fa fa-bolt has-text-black" />&nbsp;FLASH DEAL
                </span>
                <span v-else class="tag is-white">
                  <i class="fa fa-bolt has-text-grey" />&nbsp;Flash Deal ?
                </span>
              </span>
              <!-- <span
                class="tag is-grey"
                style="float: right"
                @click="toggleHidden(o)"
              >
                <span v-if="o.hidden">
                  <i class="fa fa-eye-slash has-text-danger" />&nbsp;Hidden
                </span>
                <span v-else
                  ><i class="fa fa-eye has-text-success" />&nbsp;Visible</span
                > -->

              <div style="float: right">
                <span class="icon" style="vertical-align: bottom; margin-right: 6px">
                  <span v-if="o.hidden" class="has-text-grey"><i class="fa fa-eye-slash has-text-danger fa-lg" /></span>
                  <!-- <span v-else
                    ><i class="fa fa-eye fa-lg" style="color: #35ac5e"
                  /></span> -->
                </span>
                <!-- #35AC5E -->
                <toggle-button style="font-size: 8.5pt" :value="!o.hidden" :color="{ checked: '#cdd', unchecked: '#666' }"
                  :labels="{
                    checked: 'Visible',
                    unchecked: 'Hidden',
                  }" :height="25" :width="74" @change="toggleHidden(o)" />
                <!-- <span class="icon" style="vertical-align: bottom">
                  <span v-if="o.hidden" class="has-text-grey"
                    ><i class="fa fa-eye-slash has-text-danger fa-lg"
                  /></span>
                  <span v-else
                    ><i class="fa fa-eye fa-lg" style="color: #35ac5e"
                  /></span>
                </span> -->
              </div>
              <div style="
                  margin-top: 10px;
                  padding-top: 8px;
                  border-top: 1px solid #ddd;
                ">
                <span class="button" style="padding: 6px" @click="stopEditItem">Close Item</span>
                <span class="button is-pulled-right" style="padding: 6px" @click="nextItem">Next Item&nbsp;<i
                    class="fa fa-chevron-right" /></span>
              </div>
            </div>
          </div>
          <!-- </collapse-transition> -->
        </div>
      </draggable>

      <div v-if="loading">
        <MenuEditorSkeleton />
      </div>
      <div v-else>
        <div v-if="!editingItem" style="text-align: center; padding: 9px">
          <div v-if="showIDs">
            <button class="delete is-pulled-right" @click="showIDs = false" />
            <p style="margin-bottom: 8px">
              <span class="tags has-addons" @click="copy(workflow.id)">
                <span class="tag is-dark">Workflow</span>
                <span class="tag is-white"> {{ workflow.id }}</span>
              </span>
            </p>
            <p>
              <span class="tags has-addons" @click="copy(menu.id)">
                <span class="tag is-dark">Menu Blob </span>
                <span class="tag is-white"> {{ menu.id }}</span>
              </span>
            </p>
          </div>
          <div v-else @click="showIDs = true">
            <i class="far fa-window-minimize has-text-grey" />
          </div>
        </div>
      </div>
    </section>
    <div class="bottom-wrapper is-flex">
      <a class="button has-text-primary" style="flex: 1" @click="saveMenu"><i class="fa fa-save" />&nbsp;Save</a>
      <span style="flex-shrink: 1">
        <span v-show="edited" class="button reminder is-light" disabled>Edited</span>
      </span>
    </div>
    <AdvancedMenuEditorItem v-if="selectedItem" :selectedItem="selectedItem" :business="business" :customTags="customTags"
      :optionsMenus="optionsMenus" :categories="categories" :vat="workflow.data.vat" :freeGiftItem="freeGiftItem"
      @newOptionsMenu="newOptionsMenuForItem" @addCustomCategory="addCustomCategory"
      @removeOtherFreeGift="removeOtherFreeGift" @next="selectNextItem" @close="closeSelectedItem" @save="saveItem" />
  </div>
</template>


<script>
// import EventBus from "../eventBus";
import MainBackButton from "@/components/MainBackButton";
import OptionsMenuEditor from "@/components/OptionsMenuEditor";
import MenuCategoriesEditor from "@/components/MenuCategoriesEditor";
import MenuEditorSkeleton from "@/components/MenuEditorSkeleton";
import AdvancedMenuEditorItem from "@/components/AdvancedMenuEditorItem";

import draggable from "vuedraggable";

export default {
  name: "MenuEditor",
  components: {
    MainBackButton,
    OptionsMenuEditor,
    MenuCategoriesEditor,
    MenuEditorSkeleton,
    AdvancedMenuEditorItem,
    draggable,
  },
  data() {
    return {
      blobs: null, // store the blobs here
      showSecretMenu: false,
      showIDs: false,
      showWide: false,
      selectedItems: [], // IDs of selected items
      prefaceBtn: "button is-rounded is-small is-outlined",
      filter: null, // 'out_of_stock', 'hidden'
      filters: ["Out of Stock", "Hidden", "Special", "No Category", "Schedule"],
      showItemFilters: false,
      showOptions: false,
      showCategories: false,
      showPreface: false,
      showPreOrder: false,
      menu: null, // set from blob
      items: [], // menu items: null,
      selectedItem: null, // selected item to edit
      editingItem: null, // old way
      loaderSize: Math.min(window.innerWidth * 0.75, window.innerHeight * 0.75),
      loading: false,
      z: 0,
      edited: false,
      placeholderPic: this.$store.state.menuItemPlaceholderPic,
      editCategory: false,
      editOptions: false,
      editTags: false,
      editSchedule: false,
      menuCategories: null, // set from blob
      categories: [], // set from blob if exists
      commonCategories: ["Drinks", "Noodles", "Pizza", "Desserts"],
      editingCategory: null, // selected category to edit
      addingNewCategory: false,
      contentLang: "en", // default English
      days: ["mon", "tue", "wed", "thu", "fri", "sat", "sun"], // for schedule
      defaultTags: [
        "dine-in",
        "breakfast",
        "lunch",
        "dinner",
        "vegan",
        "member",
      ], // "t12-14,17-24" thai alcohol hours
      newTags: [], // not necessarily attached to any objects yet, ephemeral
      editingPreface: false,
      menuPreface: null, // set from blob
      preface: {}, // set from blob if exists
      prefaceInput: null, // set based on lang, used by textarea input v-model
      isPrefaceDefault: false, // for updating default preface
      showOptionsMenuEditor: false,
      editingOptionsMenu: null, // selected options menu to edit
      optionsOpts: null, // pass into options menu to set things like parent_item_id
      optionsMenus: [],
      showMenuCategoriesEditor: false,
      search: null,
      reordering: false,
      selecting: false,
      showApplyActions: false,
    };
  },
  computed: {
    showSyncOptions() {
      return (
        this.obsoleteOptionsCount &&
        this.superuser &&
        this.optionsMenus.find((m) => m.data.original_id)
      );
    },
    freeGiftItem() {
      return this.items.find((i) => i.free_gift);
    },
    showMultipleCategoryBlobsWarning() {
      if (!this.blobs) return false;
      var catBlobs = this.blobs.filter(
        (b) => b.blob_type === "menu_categories"
      );
      return catBlobs.length > 1 && this.superuser; // should only have 1
    },
    filteredOptionsMenus() {
      // filter out special / non-share options menus
      return this.optionsMenus.filter(
        (m) => !m.data.type && !m.data.parent_item_id
      );
    },
    privateOptionsMenus() {
      return this.optionsMenus.filter((m) => m.data.parent_item_id);
    },
    timeOption() {
      return this.optionsMenus.find((m) => m.data.name === "Delivery Time");
    },
    dateOption() {
      return this.optionsMenus.find((m) => m.data.name === "Delivery Date");
    },
    customTags() {
      var arrays = this.items.map((i) => i.tags);
      var flat = [].concat.apply([], arrays).filter((v) => v);
      // .filter(
      //   (v) => v && !this.defaultTags.includes(v) && !this.newTags.includes(v)
      // );
      return [...new Set(flat)];
    },
    allTags() {
      var tags = this.defaultTags.concat(this.customTags);
      return tags.concat(this.newTags);
    },
    applyItems() {
      if (this.selectedItems.length) {
        return this.items.filter((i) => this.selectedItems.includes(i.id));
      }
      return this.filteredItems;
    },
    filteredItems() {
      // if (this.editingItem) {
      //   return this.items.filter((i) => this.editingItem === i.id);
      // }
      if (this.filter === "Out of Stock") {
        return this.items.filter((i) => i.out_of_stock && !i.hidden);
      }
      if (this.filter === "Hidden") {
        return this.items.filter((i) => i.hidden);
      }
      if (this.filter === "Special") {
        return this.items.filter((i) => i.special);
      }
      if (this.filter === "No Category") {
        return this.items.filter((i) => !i.category);
      }
      if (this.filter === "Schedule") {
        return this.items.filter((i) => i.schedule && i.schedule.length);
      }
      if (!this.search) return this.items;
      return this.items.filter((i) => {
        var stringItem = JSON.stringify(i).toLowerCase();
        return stringItem.includes(this.search.toLowerCase());
      });
    },
    role() {
      return this.$store.getters.getCommerceAgentRole;
    },
    superuser() {
      return this.$store.getters.isSuperUser;
    },
    business() {
      return this.role.business;
    },
    workflow() {
      return this.role.workflow; // for superuser should allow any workflow passed in URL
    },
    languages() {
      return this.workflow.data.languages || ["en", "th"]; // otherwise show default languages...
    },
    obsoleteOptionsCount() {
      var cnt = 0;
      this.items.forEach((i) => {
        if (!i.options || !i.options.length) return;
        i.options.forEach((o) => {
          if (!this.optionsMenus.find((m) => m.id === o)) cnt += 1;
        });
      });
      return cnt;
    },
    noCategoryCount() {
      return this.items.filter((i) => !i.category).length;
    },
    themeBgColor() {
      var bgColor = this.business.data.theme_color;
      if (!bgColor) return null;
      return `background-color: ${bgColor}`;
    },
    themeColor() {
      var bgColor = this.business.data.theme_color;
      if (!bgColor) return null;
      return `color: ${this.$h.textColor(bgColor)}`;
    },
  },
  mounted() {
    this.checkQuery();
  },
  activated() {
    // Object.assign(this.$data, this.$options.data()); // reset data
    this.checkQuery();
  },
  methods: {
    privateOptionsInfo() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>Private Options</p>
        <p style='margin-bottom:10px'>Private options are specific to an individual menu item.</p>
        <p>To create private options first click the menu item below, open Options and click New Options</p>
        </div>`,
      });
    },
    removeOtherFreeGift() {
      this.infoToast("Removed other free gift");
      this.freeGiftItem.out_of_stock = true;
      this.freeGiftItem.free_gift = null;
      this.saveMenu();
    },
    copyMenu() {
      // copy menu, options, categories to another commerce business
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>Copy Menu to another Business</p>
        <p style='margin-bottom:10px'>Enter the ID of the business to copy this menu to.</p>
        <p style='margin-bottom:10px'>This action will soft delete commerce workflow blobs for that business.</p>
        <p>It will create the following new blobs: </p>
        <p><code style='font-size:0.8em'>digital_menu, menu_categories,<br>options_menu(s), menu_preface</code></p>
        </div>`,
        input: "text",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t("submit"),
        inputValidator: (txt) => {
          if (!txt || txt.length < 10) return "Enter a valid ID";
        },
      }).then((val) => {
        if (val.value) this.overwriteCommerceBlobs(val.value);
      });
    },
    overwriteCommerceBlobs(toShopID) {
      var payload = {
        from: this.business.id,
        to: toShopID,
      };
      var loader = this.loadingDots("green");
      this.$store
        .dispatch("overwriteCommerceBlobs", payload)
        .then((res) => {
          this.console("overwriteCommerceBlobs success", res);
          var msg = `Successfully copied and overwritten<br>commerce blobs!`;
          this.successToast(msg, "top");
          // setTimeout(() => {
          //   this.goto("/business_profile/" + newBusinessID);
          //   this.refreshPage();
          // }, 500);
          // TODO remind user to go to that shop now to manually fix optionsIDs
          var reminder = `Remember to fix the options IDs<br>on the overwritten shop!`;
          this.warningToast(reminder, "top", 10000);
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },

    adjustPrices() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class="fa fa-money-bill-wave"></i>&nbsp;Adjust Prices</p>
        <p style='margin-bottom:10px'>Enter a number between -50 and 50 to apply as percent increase or decrease
        for all prices on the menu.</p>
        <p style='margin-bottom:10px'>Prices will be rounded up to the next integer.</p>
        <div style='font-size:0.8em; font-weight:500; opacity:0.6'>
        <p style='margin-bottom:10px'><b>10</b> means all prices will increase by 10%</p>
        <p><b>-5</b> means all prices will decrease by 5%</p>
        </div>
        </div>`,
        input: "number",
        showCloseButton: true,
        confirmButtonText: this.$t("submit"),
        inputValidator: (val) => {
          if (val < -50 || val > 50) {
            return "Enter a percent between -50% and 50%";
          }
        },
      }).then((val) => {
        if (val.value) {
          this.changePricesByPercent(val.value);
        }
      });
    },
    changePricesByPercent(p) {
      var percent = 1 + p / 100;
      this.items.forEach((i) => {
        i.price = Math.ceil(i.price * percent);
      });
      // this.saveMenu();
      var msg = `Remember to SAVE the menu<br>
      if you want to keep the new prices.<br>
      Otherwise leave this page without saving.`;
      this.successToast(msg, "bottom", 9000);
      this.showSecretMenu = false;
    },
    toggleSecretMenu() {
      this.showSecretMenu = !this.showSecretMenu;
    },
    copy(str) {
      this.$copyText(str);
      this.infoToast("Copied to clipboard!");
    },
    toggleSelect(o) {
      if (this.selectedItems.includes(o.id)) {
        var idx = this.selectedItems.indexOf(o.id);
        this.selectedItems.splice(idx, 1);
      } else {
        this.selectedItems.push(o.id);
      }
    },
    applyDelete() {
      this.warningToast("TODO: Ask Nick");
    },
    applyHidden(state) {
      this.applyItems.forEach((i) => (i.hidden = state));
      // this.filteredItems.forEach((i) => (i.hidden = state));
      this.showApplyActions = false;
      this.saveMenu();
    },
    applyOutOfStock(state) {
      this.applyItems.forEach((i) => (i.out_of_stock = state));
      // this.filteredItems.forEach((i) => (i.out_of_stock = state));
      this.showApplyActions = false;
      this.saveMenu();
    },
    // applyAvailable() {
    //   this.filteredItems.forEach((i) => (i.out_of_stock = false));
    //   this.showApplyActions = false;
    //   this.saveMenu();
    // },
    addMenuLanguage() {
      this.goto("/commerce_page/set-languages");
    },
    discountInfo() {
      var msg = "Enter a discount for item<br>as either a percent or number";
      this.infoToast(msg, "top", 6000);
    },
    createTag(o) {
      this.$swal({
        html: `<div style='text-align:left'>
  <p style='font-size:1.2em; margin-bottom:12px;'>
  <i class='fa fa-tag'></i>&nbsp;Create New Tag
  </p>
  <p>Multiple tags can be assigned to each menu item.</p>
  </div>`,
        input: "text",
        showCloseButton: true,
        showCancelButton: true,
        inputValidator: (val) => {
          if (!val) return "Enter something";
        },
      }).then((val) => {
        if (!val.value) return;
        this.newTags.push(val.value);
        this.setTag(o, val.value);
      });
    },
    toggleDiscountType(o) {
      this.clearDiscount(o);
      if (o.discount_type === "number") o.discount_type = "percent";
      else o.discount_type = "number";
      this.infoToast(`Discount type: ${o.discount_type}`);
      this.z += 1;
    },
    isPercentDiscount(o) {
      if (o.discount_type === "number") return false;
      return true;
    },
    setFilter(f) {
      this.stopEditItem();
      this.filter = f;
    },
    noCategoryInfo() {
      this.infoToast(`${this.noCategoryCount} Items not in a category`, "top");
    },
    syncOptions() {
      // check if options menu original_id can sync
      // if there's a match replace with the new id
      this.infoToast("Syncing options...", "top");
      this.items.forEach((i) => {
        if (!i.options || !i.options.length) return;
        i.options.forEach((o) => {
          if (this.optionsMenus.find((m) => m.data.original_id === o)) {
            console.log("sync options menu:", o);

            let oldID = o;
            let newID = this.optionsMenus.find(
              (m) => m.data.original_id === o
            ).id;
            let idx = i.options.indexOf(oldID);
            if (idx !== -1) i.options[idx] = newID;
            console.log(`sync idx [ ${idx} ] old ${oldID} new ${newID}`);
          }
        });
      });
      this.edited = true;
      this.z += 1;
      this.warningToast("Now SAVE and RELOAD this page!", "top");
    },
    clearObsoleteOptions() {
      // delete the obsolete options
      // var arr = this.optionsMenus.filter((m) => options.includes(m.id));
      // var obsolete = null;
      // if (options.length !== arr.length) obsolete = "!!! ";
      // return obsolete + arr.map((a) => this.optionsName(a.data)).join(", ");
      this.items.forEach((i) => {
        if (!i.options || !i.options.length) return;
        i.options.forEach((o) => {
          if (!this.optionsMenus.find((m) => m.id === o)) {
            i.options = i.options.filter((ids) => ids !== o); // this.setOptions(i, o);
          }
        });
      });
      this.edited = true;
      this.z += 1;
      this.warningToast("Remember to SAVE or not!", "top");
    },
    draggedMenu() {
      this.z += 1;
      this.edited = true;
    },
    draggedCategory() {
      this.z += 1;
      this.edited = true;
    },
    clearSelection() {
      this.selectedItems = [];
      this.selecting = false;
    },
    toggleItemFilters() {
      this.reordering = false;
      this.clearSelection();
      if (this.showItemFilters) {
        this.filter = null; // reset;
      }
      this.showItemFilters = !this.showItemFilters;
    },
    itemBackground(o) {
      if (o.hidden) return "bg-hidden";
      if (o.out_of_stock) return "bg-pink";
      if (o.flash_deal || o.free_gift) return "border-yellow"; //return "bg-yellow";
      return null;
    },
    toggleHidden(o) {
      o.hidden = !o.hidden;
      this.edited = true;
      this.z += 1;
    },
    toggleFlashDeal(o) {
      o.flash_deal = !o.flash_deal;
      if (o.flash_deal) {
        this.notifySuperusersAboutFlashDeal(o);
        this.infoToast("TUK will contact you about promoting your flash deal");
      }
      this.edited = true;
      this.z += 1;
    },
    notifySuperusersAboutFlashDeal(o) {
      this.sendEmail(o);
      var flashDeal = `FLASH DEAL @ ${this.business.name}: ${o.name}`;
      this.sendSuperuserNotification(flashDeal);
    },
    sendEmail(o) {
      this.showSetEmail = false;
      var obj = {
        type: "new_flash_deal",
        shop_name: this.business.name,
        deal: o.name,
        user_id: this.$store.state.user.id,
        uuid: this.$store.getters.getUUID,
        mobile: this.$store.getters.phoneNumber,
        name: this.$store.getters.realName,
        app: process.env.VUE_APP_TITLE,
      };
      this.$store.dispatch("sendEmail", obj).catch((err) => console.error(err));
    },
    editTimeOptionsMenu() {
      this.editOptionsMenu(this.timeOption);
      this.$refs["options-menu-editor"].setType("time");
    },
    editDateOptionsMenu() {
      this.editOptionsMenu(this.dateOption);
      this.$refs["options-menu-editor"].setType("date");
    },
    newOptionsMenuForItem(itemID) {
      var opts = null;
      if (itemID) opts = { parent_item_id: itemID };
      this.editOptionsMenu(null, opts);
    },
    editOptionsMenu(m, opts) {
      this.editingOptionsMenu = m;
      this.optionsOpts = opts;
      this.showOptionsMenuEditor = true;
    },
    closeOptionsMenu() {
      this.showOptionsMenuEditor = false;
      this.optionsOpts = null;
    },
    updateOptionsMenu(m) {
      // if (m.data.parent_item_id) this.setOptionsToParent(m);
      this.editingOptionsMenu = m;
      this.checkQuery();
    },
    closeCategoriesEditor() {
      this.showMenuCategoriesEditor = false;
      this.saveCategories();
    },
    reorderCategories(categories) {
      console.log("reorderCategories", categories);
      this.categories = categories;
      this.stopEditItem();
    },
    sortMenuItemsByCategory() {
      var catNames = this.categories.map((c) => c.name);
      this.items.sort((a, b) => {
        if (!a.category && !b.category) return 0;
        if (!a.category) return 1;
        if (!b.category) return -1;
        return catNames.indexOf(a.category) - catNames.indexOf(b.category);
      });
      this.edited = true;
    },
    advancedCategories() {
      this.showMenuCategoriesEditor = true;
      // this.infoToast("Advanced categories coming soon");
    },
    defaultImg(e) {
      e.target.src = this.$store.state.menuItemPlaceholderPic;
    },
    checkQuery() {
      var query = this.$route.query; // superuser can use this to edit any menu...soon
      if (query.workflow && this.superuser) {
        this.getBlobs(query.workflow); // << needs to be workflow_id
        alert("YOU A SUPER!");
      } else {
        // this.role.workflow_id
        this.getBlobs(); // << pass in workflow_id
      }
    },
    viewMenu() {
      if (this.edited) this.saveEditsReminder();
      else this.goto("/shop/" + this.business.id);
    },
    optionsName(o) {
      return o[this.contentLang] || o.name;
    },
    optionsList(options) {
      // var arr = this.optionsMenus.filter((m) => options.includes(m.id)); // << not correct order
      var arr = [];
      options.forEach((o) => {
        var m = this.optionsMenus.find((m) => o === m.id);
        if (m) arr.push(m);
      });
      var obsolete = "";
      if (options.length !== arr.length) obsolete = "!!! ";
      return obsolete + arr.map((a) => this.optionsName(a.data)).join(", ");
    },
    categoryName(c) {
      var cat = this.categories.find((o) => o.name === c);
      if (!cat) return "!! " + c; // category doesn't exist
      return cat[this.contentLang] || cat.name;
    },
    editCategoryName() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em'><i class='fa fa-cat'></i>&nbsp;Edit Category Name</p>
        </div>`,
        input: "text",
        inputValue: this.editingCategory.name,
        showCloseButton: true,
        inputValidator: (txt) => {
          if (!txt) return "Enter a name";
        },
      }).then((val) => {
        if (val.value) {
          // need to change category name on existing items
          this.updateCategoryOnItems(this.editingCategory.name, val.value);
          this.editingCategory.name = val.value;
          this.saveCategories();
        }
      });
    },
    stopEditCategory() {
      this.editingCategory = null;
      this.saveCategories();
    },
    updateCategoryOnItems(oldName, newName) {
      this.items.forEach((i) => {
        if (i.category === oldName) {
          i.category = newName;
          this.edited = true;
        }
      });
    },
    addNewCategory() {
      this.addingNewCategory = true;
    },
    addDefaultCategory(name) {
      if (this.categories.find((c) => c.name === name)) {
        return this.warningToast("Category exists");
      }
      this.categories.push({ name: name });
      this.saveCategories();
      this.addingNewCategory = false;
    },
    addCustomCategory() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'><i class='fa fa-list-ul'></i>&nbsp;Add Category</p>
        <p style='margin-bottom:10px'>You can create any category name you want.</p>
        <p style='margin-bottom:10px'>Each product can only have one category assigned to it.</p>
        <p style='font-size:0.9em; font-weight:500; color:grey'>For example: Mains, Sides, Desserts</p>
        </div>`,
        input: "text",
        inputPlaceholder: "Desserts",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Create",
        inputValidator: (txt) => {
          if (!txt) return "Enter category name";
        },
      }).then((val) => {
        if (val.value) {
          // check if duplicate
          var name = this.capitalise(val.value);
          if (this.categories.find((c) => c.name === name)) {
            return this.warningToast("Category exists");
          }
          this.categories.push({ name: name }); // default Name, later can add language translations: en, th, zh
          this.saveCategories();
        }
        this.addingNewCategory = false;
      });
    },
    capitalise(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    saveItem(item, save) {
      console.log("saveItem new", item);
      var old = this.items.find((i) => i.id === item.id);
      console.log("oldItem", old);
      if (old) Object.assign(old, item); //old = item;
      // this.z += 1;
      if (typeof save === "undefined") this.saveMenu();
    },
    closeSelectedItem() {
      this.selectedItem = null;
      this.stopEditItem();
    },
    selectNextItem(item) {
      this.saveItem(item, false); // first save previous item
      var idx = this.items.map((i) => i.id).indexOf(this.selectedItem.id);
      var maxIdx = this.items.length - 1;
      var nextIdx = idx + 1;
      if (nextIdx > maxIdx) nextIdx = 0;
      // this.stopEditItem();
      // this.selectedItem = null;
      // this.$nextTick(() => this.selectItem(this.items[nextIdx]));
      this.selectItem(this.items[nextIdx]);
    },
    resetEdit() {
      this.editCategory = false; // close this
      this.editOptions = false;
      this.editTags = false;
      this.editSchedule = false;
    },
    stopEditItem() {
      this.resetEdit();
      this.editingItem = null;
    },
    nextItem() {
      var idx = this.items.map((i) => i.id).indexOf(this.editingItem);
      var maxIdx = this.items.length - 1;
      var nextIdx = idx + 1;
      if (nextIdx > maxIdx) nextIdx = 0;
      this.stopEditItem();
      this.$nextTick(() => this.editItem(this.items[nextIdx].id));
    },
    selectItem(o) {
      this.selectedItem = o;
      // this.editItem(o.id);
      this.editingItem = o.id;
    },
    editItem(id) {
      this.resetEdit();
      this.editCategory = false; // close this
      if (this.editingItem === id) {
        this.stopEditItem();
        // this.editingItem = null;
      } else {
        this.editingItem = id;
        var opts = null; //{ behavior: "smooth" };
        this.$nextTick(() =>
          this.$el.querySelector(`[data-item='${id}']`).scrollIntoView(opts)
        );
      }
    },
    optionsItemCount(id) {
      return this.items.filter((i) => {
        return i.options && i.options.includes(id);
      }).length;
    },
    catItemCount(catName) {
      return this.items.filter((i) => i.category === catName).length;
    },
    editCategories(c) {
      // editing a master category
      this.editingCategory = c;
      this.addingNewCategory = false; // close green panel if it was open
      this.languages.forEach((l) => {
        if (!this.editingCategory[l]) {
          this.editingCategory[l] = this.editingCategory.name;
        }
      });
    },
    deleteCategory() {
      if (this.catItemCount(this.editingCategory.name)) {
        this.updateCategoryOnItems(this.editingCategory.name, null);
        this.warningToast("Remember to save menu items!");
      }
      var index = this.categories.indexOf(this.editingCategory);
      this.categories.splice(index, 1);
      this.saveCategories();
      this.editingCategory = null;
    },
    setCategory(o, catName) {
      if (o.category === catName) {
        o.category = null;
      } else {
        o.category = catName;
        this.editCategory = false;
      }
      this.edited = true;
    },
    clearSchedule(o) {
      o.schedule = null;
      this.edited = true;
      this.z += 1;
    },
    setSchedule(o, day) {
      if (!o.schedule) o.schedule = [];
      if (o.schedule.includes(day)) {
        o.schedule = o.schedule.filter((d) => d !== day);
      } else {
        o.schedule.push(day);
      }
      if (o.schedule.length === 7) o.schedule = null; // all days
      this.edited = true;
      this.z += 1;
    },
    isScheduleDay(o, d) {
      if (!o.schedule) return false;
      return o.schedule.includes(d);
    },
    setTag(o, tag) {
      if (!o.tags) o.tags = [];
      if (o.tags.includes(tag)) {
        o.tags = o.tags.filter((t) => t !== tag);
      } else {
        o.tags.push(tag);
      }
      this.edited = true;
      this.z += 1;
    },
    isTag(o, t) {
      if (!o.tags) return false;
      return o.tags.includes(t);
    },
    setOptions(o, m) {
      if (!o.options) o.options = [];
      if (o.options.includes(m.id)) {
        o.options = o.options.filter((o) => o !== m.id);
      } else {
        o.options.push(m.id);
      }
      this.edited = true;
      this.z += 1;
    },
    // setOptionsToParent(m) {
    //   console.log("setOptionsToParent", m, this.items[0]);
    //   var o = this.items.find((o) => o.id === m.data.parent_item_id);
    //   if (!o) return;
    //   if (!o.options) o.options = [];
    //   if (o.options.includes(m.id)) return; // already attached to parent
    //   o.options.push(m.id);
    //   this.edited = true;
    //   this.z += 1;
    // },
    isOptions(o, m) {
      if (!o.options) return false;
      return o.options.includes(m.id);
    },
    toggleOutOfStock(o) {
      o.out_of_stock = !o.out_of_stock;
      this.z += 1;
      this.edited = true;
    },
    setAvailable(o) {
      o.out_of_stock = false;
      this.z += 1;
      this.edited = true;
    },
    setOutOfStock(o) {
      o.out_of_stock = true;
      this.z += 1;
      this.edited = true;
    },
    toggleSpecial(o) {
      o.special = !o.special;
      this.z += 1;
      this.edited = true;
      if (o.special) this.successToast("Added special!", "top");
    },
    setSpecial(o, state) {
      console.log("setSpecial", state, o);
      o.special = state;
      this.edited = true;
    },
    clearDiscount(o) {
      o.discount = null;
      this.edited = true;
    },
    validateDiscount(o) {
      if (o.discount == 0) {
        this.clearDiscount(o);
        return;
      }
      if (this.isPercentDiscount(o)) {
        if (o.discount < 1 || o.discount > 100) {
          var msg = `Invalid percent discount: ${o.discount} %<br>Enter an integer percent between 1 - 100 %`;
          // alert(msg);
          this.errorToast(msg, "top");
          o.discount = null;
        }
      } else {
        console.log("check number discount", o.discount, o.price);
        if (parseInt(o.discount) > parseInt(o.price)) {
          msg = `Number discount greater than item price<br>${o.discount} > ${o.price}`;
          this.warningToast(msg, "top");
          o.discount = o.price;
        }
      }
      o.discount = Math.trunc(o.discount);
      this.edited = true;
    },
    saveEditsReminder() {
      var green = this.bulmaColor("primary");
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='margin-bottom:12px; font-size:1.2em'>
        <i class="fa fa-save"></i>&nbsp;Remember to Save
        </p>
        <p>Do you want to save your list edits before leaving this page?</p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t("save"),
        cancelButtonText: this.$t("cancel"),
        confirmButtonColor: green,
      }).then((val) => {
        if (val.value) this.saveMenu();
        else this.edited = false;
      });
    },
    initBlobs(blobs) {
      // init the menu
      this.blobs = blobs;
      this.menu = blobs.find((b) => b.blob_type === "digital_menu");
      if (this.menu) this.items = this.menu.data;
      if (this.items.length === 0) this.addItemToMenu(); // think this is not used
      this.setContentLang("en", true);
      // if (this.items[0].languages) {
      //   this.languageBool = this.items[0].languages[this.contentLang];
      // }

      // init categories
      var mcBlob = blobs.find((b) => b.blob_type === "menu_categories");
      this.menuCategories = mcBlob;
      if (this.menuCategories) this.categories = this.menuCategories.data;

      // init preface
      this.menuPreface = blobs.find((b) => b.blob_type === "menu_preface");
      if (this.menuPreface) {
        this.preface = this.menuPreface.data;
        this.prefaceInput =
          this.preface[this.contentLang] || this.preface.preface;
      }

      // init options
      this.optionsMenus = blobs.filter((b) => b.blob_type === "options_menu");
      this.optionsMenus = this.optionsMenus.sort((a, b) => {
        return this.optionsName(a.data).localeCompare(this.optionsName(b.data));
      });
      this.checkVatable();
    },
    checkVatable() {
      // console.log("checkVatable", this.workflow.data);
      if (!this.workflow.data.vat) return;
      this.items.forEach((i) => {
        if (i.hasOwnProperty("vatable")) return;
        i.vatable = true;
        this.edited = true;
      });
    },
    getBlobs() {
      if (!this.role) return this.warningAlert("Invalid Role");
      this.loading = true;
      this.$store
        .dispatch("getBlobsForWorkflow", this.role.workflow_id)
        .then((res) => {
          console.log("getBlobsForWorkflow", res);
          if (res.data) this.initBlobs(res.data); // if there are blobs, initialise them
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.loading = false));
    },
    saveContent() {
      this.items.forEach((o) => {
        o[this.contentLang] = {
          name: o.name,
          description: o.description,
        };
      });
    },
    setContentLang(lang, isInit) {
      // if (!isInit) this.saveContent();
      this.contentLang = lang;
      this.setContent();
      this.editingPreface = false; // close this in case it was open
      // this.z += 1; // should change the item names lang etc
    },
    setContent() {
      this.items.forEach((o) => {
        if (o[this.contentLang]) {
          o.name = o[this.contentLang].name;
          o.description = o[this.contentLang].description;
        }
      });
      // this.languageBool = false;
      // if (this.items.length > 0) {
      //   if (!this.items[0].languages) return;
      //   this.languageBool = this.items[0].languages[this.contentLang];
      // }
    },
    saveMenu() {
      this.sortMenuItemsByCategory(); // sort menu every time before saving
      this.menu.data = this.items; // update menu items
      var loader = this.loadingDots("purple");
      this.$store
        .dispatch("saveBlob", this.menu)
        .then((res) => {
          this.menu = res.data;
          this.edited = false;
          // this.success();
          this.successToast("Menu edits saved!");
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    saveCategories() {
      if (this.menuCategories) {
        this.menuCategories.data = this.categories;
      } else {
        this.menuCategories = {
          parent_type: "workflow",
          parent_id: this.role.workflow_id,
          blob_type: "menu_categories",
          data: this.categories,
        };
      }
      this.$store
        .dispatch("saveBlob", this.menuCategories)
        .then((res) => {
          this.menuCategories = res.data;
          this.successToast("Category edits saved!");
        })
        .catch((err) => this.apiError(err));
    },
    editPreface() {
      this.editingPreface = true;
      var p = this.preface;
      this.prefaceInput = p[this.contentLang] || p.preface;
      this.isPrefaceDefault = false; // set back to false in case it had been changed
    },
    undoPreface() {
      this.infoToast("Undo preface edits");
      this.editingPreface = false;
    },
    deletePreface() {
      this.$swal({
        title: `<i class='fa fa-trash-alt' style='color:red'></i>`,
        html: "Are you sure you want to delete the preface?",
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: "Oops, keep it",
        confirmButtonText: "Yes, delete",
        confirmButtonColor: this.bulmaColor("danger"),
      }).then((val) => {
        if (val.value) this.savePreface(true);
      });
    },
    savePreface(isDelete) {
      if (isDelete) {
        this.preface = {};
      } else {
        this.preface[this.contentLang] = this.prefaceInput; // set the lang
        if (!this.preface.preface || this.isPrefaceDefault) {
          this.preface.preface = this.prefaceInput; // set default
        }
      }

      // prepare the menu_preface object
      if (this.menuPreface) {
        this.menuPreface.data = this.preface;
      } else {
        this.menuPreface = {
          parent_type: "workflow",
          parent_id: this.role.workflow_id,
          blob_type: "menu_preface",
          data: this.preface,
        };
      }
      var loader = this.loadingDots("orange");
      this.$store
        .dispatch("saveBlob", this.menuPreface)
        .then((res) => {
          this.menuPreface = res.data; // need to update here else another save will create duplicate
          this.successToast("Menu preface saved!");
          this.editingPreface = false;
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.menu-editor {
  height: 100vh;
  width: 100vw;
  max-width: 600px;
  overflow: hidden;
  text-align: left;
}

.full-width {
  max-width: initial;
}

.header {
  text-align: left;
  font-size: 1.3em;
  font-weight: 500;
  padding-left: 60px;
  padding-top: 14px;
  margin-bottom: 8px;
}

.centered {
  z-index: 8;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.menu-pic {
  flex-shrink: 1;
  height: 88px;
  position: relative;
}

.contain-img {
  object-fit: contain !important;
}

.column img,
.is-flex img {
  object-fit: cover;
  height: 80px;
  width: 80px;
  border-radius: 2px;
  /* border-radius: 3px; */
  /* margin-top: 7px; */
  margin: 4px;
  margin-right: 6px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}

.no-img {
  /* margin-left: 1px; */
  border-radius: 2px;
  object-fit: cover;
  height: 80px;
  width: 80px;
  /* box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.14); */
  margin: 4px;
  margin-right: 6px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}

.column {
  padding: 0 0;
  padding-left: 7px;
}

.items-list {
  border-top: 1px solid #eee;
}

.menu-item {
  /* margin: 5px 10px; */
  /* margin-bottom: 14px; */
  background-color: white;
  border-bottom: 1px solid #eee;
  position: relative;
  /* width: 100%; */
}

.editing-item {
  margin: 6px 3px;
  box-shadow: 0 0 6px grey;
  border-radius: 4px;
  /* z-index: 2; */
  /* position: absolute; */
}

/* .menu-item .is-flex {
  background-color: white;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.14);
} */
.columns {
  position: relative;
  left: -6px;
  width: calc(100vw - 4px);
  /* margin: 5px 10px; */
  padding: 0 0;
  /* border: 1px solid rgba(128, 128, 128, 0.482); */
  /* border-radius: 5px; */
  background-color: white;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.14);
}

.advanced {
  z-index: 0;
  /* border: 1px solid rgba(0, 0, 255, 0.4); */
  padding: 6px;
  /* padding: 15px 6px; */
  /* margin: -10px; */
  /* margin-top: -18px; */
  border-top: 1px solid rgba(230, 230, 230, 0.5);
  /* margin-bottom: 12px; */
  /* background-color: rgba(220, 220, 219, 0.552); */
  /* background-color: white; */
  /* box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.251); */
  /* max-width: 100vw; */
  max-width: 100%;
  overflow: hidden;
}

/* .notification {
  text-align: left;
  padding: 10px;
  margin: 0;
  overflow-y: scroll;
  height: calc(100vh - 110px);
} */
.wrapper {
  position: relative;
  overflow-y: scroll;
  height: calc(100vh - 110px);
}

.edit-shield {
  position: absolute;
  top: 0;
  left: 0;
  padding: 30px;
  z-index: 21;
  /* MainBackButton is z-index = 20 */
}

.reminder {
  /* position: absolute; */
  /* bottom: 0; */
  /* right: 0; */
  float: right;
  /* padding: 10px; */
  color: rgba(255, 0, 0, 0.8);
  font-weight: 500;
}

.discount {
  text-decoration: line-through;
  color: #777;
}

.categories span {
  margin-right: 6px;
}

.button.is-small.is-rounded {
  padding: 0 6px;
}

.single-line {
  white-space: nowrap;
  overflow: auto;
  display: inline-block;
}

.availability .button {
  margin-right: 8px;
  font-weight: 500;
  /* color: black; */
  /* box-shadow: 1px 1px 1px rgba(128, 128, 128, 0.7); */
}

.fa-external-link-alt {
  padding-right: 15px;
  margin-top: -2px;
}

.buttons {
  margin-bottom: 4px;
}

.wleft .button {
  width: 110px;
  border: 1px solid #ddd;
}

.click-set {
  /* color: rgba(0, 0, 255, 0.8); */
  color: grey;
  background-color: rgb(255, 255, 149);
  padding: 0 5px;
  border-radius: 20px;
  /* box-shadow: 1px 1px 5px #ccc; */
  border: 1px solid #eee;
}

.category-edit {
  text-align: left;
  padding: 6px;
  margin-top: 6px;
  border: 1px solid #ddd;
  /* background-color: rgb(255, 255, 132); */
  /* background-color: rgb(227, 227, 227); */
  border-radius: 4px;
  /* box-shadow: 0 0 2px grey; */
}

.choose-category {
  padding: 4px;
  border: 1px solid #eee;
  border-radius: 5px;
  background-color: white;
  margin-bottom: 10px;
}

.new-category {
  background-color: white;
  /* background-color: rgb(227, 227, 227); */
  padding: 10px;
  margin-top: 0px;
  /* border-radius: 5px; */
  box-shadow: 0 0 2px grey;
}

.special {
  position: absolute;
  padding: 2px;
  margin: 2px;
  background-color: rgba(255, 217, 0, 0.8);
  border-radius: 2px;
}

.flash {
  position: absolute;
  left: 67px;
  padding: 2px 4px;
  margin: 2px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 2px;
}

.counter {
  background-color: #eee;
  border-radius: 20px;
  padding: 0 8px;
  margin-right: -10px;
}

.counter-btn {
  padding-left: 9px;
  padding-right: 3px;
}

.bg-pink {
  background-color: rgb(255, 207, 215);
}

.bg-hidden {
  background-color: rgb(212, 212, 212);
}

.bg-yellow {
  background-color: rgb(255, 217, 0);
}

.out-of-stock {
  position: absolute;
  left: 2px;
  bottom: 2px;
  padding: 3px;
  opacity: 0.7;
  width: 84px;
}

.preface {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 4px 8px;
  white-space: pre;
}

.clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* clamp ellipsis single line */
  -webkit-box-orient: vertical;
  padding-right: 4px;
}

.filters {
  border-top: 1px solid rgb(240, 240, 240);
  margin-top: 9px;
  padding-top: 6px;
  width: 100%;
}

.filters .button {
  margin-right: 8px;
  margin-bottom: 4px;
}

.reorder-btn {
  font-size: 0.8em;
  padding: 2px 4px;
}

.wleft .fa,
.wleft .far {
  color: grey;
}

.fa-chevron-left {
  margin-right: 6px;
}

.cat-tag {
  background-color: #eee;
  border-radius: 3px;
  padding: 0 2px;
  line-height: 0.8em;
  font-size: 0.85em;
}

.top-bar {
  /* position: absolute; */
  top: 0;
  height: 56px;
  /* width: 100vw; */
  text-align: left;
  background-color: rgb(59, 59, 59);
  z-index: 1;
}

.top-bar p {
  margin-left: 60px;
  /* margin-top: 15px; */
  padding-top: 15px;
  font-size: 1.1em;
  font-weight: 500;
  /* max-width: calc(100vw - 108px); */
  color: lightgoldenrodyellow;
  white-space: nowrap;
  overflow: auto;
}

.row {
  font-weight: 500;
  opacity: 0.6;
}

.row-wrapper {
  background-color: white;
  padding: 6px 10px;
}

.divider {
  height: 8px;
}

.bottom-wrapper {
  margin: 10px;
  /* box-shadow: 0 0 3px black; */
}

.item-name {
  flex: 1;
  font-weight: 450;
  min-height: 50px;
  /* height: initial; */
  margin-top: 6px;
  overflow: hidden;
}

.item-name.clamp {
  height: 50px;
}

.action-col {
  flex-shrink: 1;
  padding: 0 10px;
  line-height: 88px;
  background-color: #ddd;
}

.close-item {
  position: absolute;
  margin-top: -20px;
  padding: 10px;
  left: calc(50% - 18px);
}

.selected-count {
  background-color: #eef;
  box-shadow: 0 0 1px blue;
  border-radius: 20px;
  color: blue;
  padding: 0px 7px;
}

.selected-filter {
  background-color: #eee;
  border-radius: 4px;
  /* margin-left: 16px; */
  padding: 4px 8px;
}

.apply-action-btn {
  background-color: #fff;
  border-radius: 40px;
  padding: 2px 9px;
  margin-top: -2px;
  margin-left: 10px;
  border: 1px solid#3273DC;
  color: #3273dc;
  cursor: pointer;
}

.apply-actions-wrapper {
  background-color: #eef;
  /* background-color: white; */
  padding: 10px;
  position: absolute;
  left: 0;
  margin-top: -4px;
  z-index: 5;
  /* border-radius: 4px; */
  box-shadow: 0 0 5px grey;
  width: 100vw;
  max-width: 600px;
}

.apply-btns {
  /* margin-bottom: 0; */
}

.apply-btns .button {
  margin-bottom: 0;
  margin-top: 6px;
  font-size: 0.8em;
  border-radius: 20px;
  padding: 7px;
}

.reordering {
  background-color: #eee;
  padding: 24px 12px;
  position: absolute;
  right: 3px;
  margin-top: -5px;
  z-index: 2;
  font-size: 1.2em;
  font-weight: 500;
  border-radius: 4px;
  box-shadow: 0 0 1px grey;
}

.reordering .fa-grip-lines {
  border: 1px solid white;
  border-radius: 4px;
  padding: 2px 6px;
}

.border-yellow {
  box-shadow: inset 0 0 0 5px var(--warning);
}

.estimated-weight {
  font-size: 0.75em;
  font-weight: 500;
  margin-left: 6px;
  background-color: #444;
  color: white;
  border-radius: 3px;
  padding: 0 3px;
}
</style>